import type { AppointmentFormTypes as Types } from '@grandvisionhq/appointments'

export const consents: Types.ConsentOptIn[] = [
  {
    title: 'appointments.consent.createAccount',
    value: 'createAccount',
    required: true,
  },
  {
    title: 'appointments.consent.termsConditionsAndPolicies',
    value: 'termsConditionsAndPolicies',
    required: true,
    children: [
      {
        title: 'appointments.optIn.marketingEmails',
        value: 'subscribe-newsletter',
      },
    ],
  },
]

export const optIns: Types.ConsentOptIn[] = []
